import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ActionsBarPres from './ActionsBarPres';

import ConsentPage from './ConsentPage';
import SummaryPage from './SummaryPage';

import ServiceAddPres from '../../ServiceInit/presentational/ServiceAddPres';

export const ConsentPres = ({
  toggleModal,
  menu,
  viewType,
  percentProgress,
  currentMenuPage,
  isNextDisabled,
  isFirstPage,
  isMenuVisible,
  isSubmitDisabled,
  showSummaryPage,
  isDownloadDisabled,
  isDraftVisible,
  isDraftDisabled,
  onSaveDraft,
  onCancel,
  onSubmit,
  onNextPage,
  onPrevPage,
  consentState,
  togleConsent,
  onDownload,
  consentRefs,
}) => {
  const { pageIdx, pages } = consentState;
  let consent = {},
    pageHTML = '',
    accepted = false,
    acceptable = pages && pages[pageIdx] && !!pages[pageIdx].read;

  if (!showSummaryPage) {
    consent = (pages && pages[pageIdx] && pages[pageIdx].consentData) || {};
    pageHTML = consent.consentDefinitionKey && consent.consentDefinitionKey[0] ? consent.consentDefinitionKey[0].consentData : '';
    accepted = (pages[pageIdx] && pages[pageIdx].accepted) || false;
  }

  return (
    <Fragment>
      {!showSummaryPage && (
        <ConsentPage pageHTML={pageHTML} togleConsent={togleConsent} accepted={accepted} acceptable={acceptable} ref={consentRefs} />
      )}
      {showSummaryPage && <SummaryPage />}
      <ActionsBarPres
        percentProgress={percentProgress}
        isNextDisabled={isNextDisabled}
        isFirstPage={pageIdx === 0}
        isDraftVisible={isDraftVisible}
        isSubmitDisabled={isSubmitDisabled}
        isDraftDisabled={isDraftDisabled}
        isDownloadDisabled={isDownloadDisabled}
        isLastPage={false}
        onSaveDraft={onSaveDraft}
        onCancel={toggleModal.bind(null, true)}
        onSubmit={onSubmit}
        onNextPage={onNextPage}
        onPrevPage={onPrevPage}
        onDownload={onDownload}
      />
    </Fragment>
  );
};

ServiceAddPres.propTypes = {
  showModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  menu: PropTypes.array.isRequired,
  viewType: PropTypes.string.isRequired,
  percentProgress: PropTypes.number.isRequired,
  currentMenuPage: PropTypes.number.isRequired,
  isNextDisabled: PropTypes.bool,
  isFirstPage: PropTypes.bool,
  isMenuVisible: PropTypes.bool,
  isSubmitDisabled: PropTypes.bool,
  showSummaryPage: PropTypes.bool,
  isDownloadDisabled: PropTypes.bool,
  isDraftDisabled: PropTypes.bool.isRequired,
  onSaveDraft: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onNextPage: PropTypes.func.isRequired,
  onPrevPage: PropTypes.func.isRequired,
  changeMenuPage: PropTypes.func.isRequired,
  onDownload: PropTypes.func,
  pages: PropTypes.object,
  consentState: PropTypes.object,
  togleConsent: PropTypes.func,
};

export default ConsentPres;
